import { Card, CardContent } from "@/components/ui/card";

import { PropsWithChildren } from "react";
import FloatingWaveLayout from "./floating-wave-layout";

const BasicLayout = ({ children, size = "m" }: PropsWithChildren & { size?: "s" | "m" | "l" | "xl" }) => {
  const sizeClass = {
    s: "max-w-xl",
    m: "max-w-2xl",
    l: "max-w-3xl",
    xl: "max-w-5xl",
  };
  return (
    <div className="min-h-screen w-screen bg-gray-50 flex flex-col ">
      <FloatingWaveLayout>
        <header className="bg-transparent backdrop-blur-md border-b border-gray-200 py-4">
          <img src="/zoooz_header.svg" alt="Zoooz – מאגר מידע פילנתרופי" width={200} height={60} className="mx-auto" />
        </header>
        <main className="flex-1 flex flex-col items-center  p-4">
          <Card
            className={`w-full ${sizeClass[size]} shadow-lg border bg-transparent backdrop-blur-xl border-zoooz-primary rounded-lg`}>
            <CardContent className="flex flex-col items-center p-8">{children}</CardContent>
          </Card>
        </main>
      </FloatingWaveLayout>
    </div>
  );
};
export default BasicLayout;
